"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _LoadingBar = _interopRequireDefault(require("./LoadingBar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-around;\n  margin: 4vh auto 0.55vh;\n  position: relative;\n  width: 100%;\n  @media (max-width: 768px) {\n    margin: 0;\n    width: initial;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 14px;\n  font-weight: ", ";\n  line-height: 24px;\n  text-align: center;\n  text-transform: capitalize;\n  color: #646464;\n  margin-top: 1.8vh;\n  @media (max-width: 768px) {\n    display: ", ";\n    margin-top: 0;\n    margin-left: 2vw;\n    text-align: justify;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Status = _styledComponents.default.span(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.font;
}, function (_ref2) {
  var active = _ref2.active;
  return active ? 'bold' : 'initial';
}, function (_ref3) {
  var active = _ref3.active;
  return active ? 'inline' : 'none';
});

var ClaimStatus = function ClaimStatus(_ref4) {
  var className = _ref4.className,
      active = _ref4.active,
      counter = _ref4.counter,
      stage = _ref4.stage;
  return _react.default.createElement(Status, {
    className: className,
    active: active
  }, counter, ". ", stage.name);
};

var ProgressBar = function ProgressBar(_ref5) {
  var activeId = _ref5.activeId,
      background = _ref5.background,
      filledColor = _ref5.filledColor,
      className = _ref5.className,
      height = _ref5.height,
      stages = _ref5.stages,
      stepsLength = _ref5.stepsLength,
      otherProps = _objectWithoutProperties(_ref5, ["activeId", "background", "filledColor", "className", "height", "stages", "stepsLength"]);

  return _react.default.createElement(StyledProgressBar, _extends({}, otherProps, {
    className: className
  }), _react.default.createElement(_LoadingBar.default, {
    stagesLength: stepsLength || stages.length,
    activeId: activeId,
    background: background,
    filledColor: filledColor,
    height: height
  }), stages.map(function (stage, i) {
    return _react.default.createElement(ClaimStatus, {
      key: stage.id,
      stage: stage,
      stages: stages,
      active: activeId === stage.id,
      counter: i + 1
    });
  }));
};

var StyledProgressBar = _styledComponents.default.div(_templateObject2());

ProgressBar.defaultProps = {
  activeId: 1,
  height: '7px',
  otherProps: {},
  stages: [{
    key: 'start',
    name: 'start',
    id: 1
  }, {
    key: 'middle',
    name: 'middle',
    id: 2
  }, {
    key: 'end',
    name: 'end',
    id: 3
  }]
};
ProgressBar.propTypes = {
  activeId: _propTypes.number,
  background: _propTypes.string,
  className: _propTypes.string,
  filledColor: _propTypes.string,
  height: _propTypes.string,
  otherProps: _propTypes.object,
  stages: (0, _propTypes.arrayOf)(_propTypes.object),
  stepsLength: _propTypes.number
};
var _default = ProgressBar;
exports.default = _default;